import { render, staticRenderFns } from "./AppointmentReport.vue?vue&type=template&id=91837e18&"
import script from "./AppointmentReport.vue?vue&type=script&lang=js&"
export * from "./AppointmentReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports